<template>
  <div>
    <PublicLayout>
      <!-- carousel -->
      <div>
        <img
          :src="
            require('@/assets/public/images/home/新官網首頁圖_工作區域_1.png')
          "
          alt="官網首頁圖"
          class="d-none d-md-block w-100"
        />
        <img
          :src="require('@/assets/public/images/home/新官網首頁圖-2(直).png')"
          alt="官網首頁圖手機版"
          class="d-block d-md-none w-100"
        />
      </div>
      <!-- <b-carousel
        id="carousel-fade"
        style="text-shadow: 0px 0px 2px #000"
        fade
        indicators
        img-width="1024"
        img-height="480"
      >
        <b-carousel-slide
          v-for="(img, idx) in homepageSlides"
          :key="idx"
          :img-src="img.previewUrl"
        ></b-carousel-slide>
      </b-carousel> -->
      <!-- carousel -->
      <section class="mt-3">
        <div
          class="m_sec2__nucleicAcid"
          :style="{
            backgroundImage: `url(${require('@/assets/public/images/home/bg_nucleic_acid.jpeg')})`,
          }"
        >
          <div class="container text-center">
            <div class="row justify-content-center">
              <div class="col-md-8">
                <h2 class="m_ttl7">
                  axit nucleic là gì  <!--何謂核酸-->

                  <span>About Nucleic Acid</span>
                </h2>
                <p class="u_mincho u_center mb-4">
                  Suy nghĩ về sức khỏe từ dinh dưỡng di truyền <!--從基因營養學思考健康-->
                  <br />Loại “axit nucleic” được nhiều người mong đợi<!--備受矚目的“核酸”-->
                </p>
                <router-link to="/kakusan" class="m_btn m_btn__white"
                  >tìm hiểu thêm<!--了解更多--></router-link
                >
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="m_sec2">
          <div class="container-fluid">
            <h2 class="m_ttl7">
              aGiới thiệu về Fudizi <!--關於富地滋-->
              <span>About us</span>
            </h2>
            <div class="row">
              <div class="col-md-4">
                <router-link to="/company">
                  <img
                    :src="
                      require('@/assets/public/images/home/img_company_thumb.jpeg')
                    "
                    alt="企業情報"
                    class="w-100"
                  />
                  <div class="m_media_detail mt-3 text-center">
                    <p class="m_media_ttl">trí tuệ doanh nghiệp<!--企業情報--></p>
                    <p>Giới thiệu về Nissho Fortune<!--關於日商富地滋--></p>
                  </div>
                </router-link>
              </div>
              <div class="col-md-4">
                <router-link to="/safety">
                  <img
                    :src="
                      require('@/assets/public/images/home/img_safety_thumb.jpeg')
                    "
                    alt=""
                    class="w-100"
                  />
                  <div class="m_media_detail mt-3 text-center">
                    <p class="m_media_ttl">Chất lượng của Fudizi<!--富地滋的品質--></p>
                    <p>
                      Hệ thống đảm bảo chất lượng hoàn chỉnh và đáng tin cậy<!--完整確實的品質保證體制--> <br />
                      Cung cấp sản phẩm an toàn và đảm bảo<!--提供安全與安心的產品-->
                    </p>
                  </div>
                </router-link>
              </div>
              <div class="col-md-4">
                <router-link to="/contribution">
                  <img
                    :src="
                      require('@/assets/public/images/home/img_contribution_thumb.png')
                    "
                    alt=""
                    class="w-100"
                  />
                  <div class="m_media_detail mt-3 text-center">
                    <p class="m_media_ttl">đóng góp xã hội<!--社會貢獻--></p>
                    <p>「Đầu tư cho tương lai」 Hoạt động đóng góp xã hội của Futez<!--「對未來的投資」 富地滋的社會貢獻活動--></p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="m_sec">
          <div class="container-fluid">
            <h2 class="m_ttl7">
              Thông tin sản phẩm<!--產品資訊-->
              <span>Products</span>
            </h2>
            <div class="text-center">
              <h3 class="m_ttl3">bổ sung dinh dưỡng<!--營養補助食品--></h3>
              <div class="home-product-list">
                <router-link to="/products/1">
                  <img
                    :src="
                      require('@/assets/public/images/home/產品資訊_產品單圖-05.png')
                    "
                    alt=""
                  />
                </router-link>
                <router-link to="/products/2">
                  <img
                    :src="
                      require('@/assets/public/images/home/產品資訊_產品單圖-06.png')
                    "
                    alt=""
                  />
                </router-link>
                <router-link to="/products/11">
                  <img
                    :src="
                      require('@/assets/public/images/home/產品資訊_產品單圖-07_2023.png')
                    "
                    alt=""
                  />
                </router-link>
              </div>
              <h3 class="m_ttl3 mt-4">Sản phẩm chăm sóc da<!--保養品--></h3>
              <div class="home-product-list">
                <a href="/products#productCareSec">
                  <img
                    :src="
                      require('@/assets/public/images/home/產品資訊_產品單圖-08_2023.png')
                    "
                    alt=""
                  />
                </a>
                <a href="/products#productMousaSec">
                  <img
                    :src="
                      require('@/assets/public/images/home/產品資訊_產品單圖-09.png')
                    "
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- main-section -->
      <section class="m_sec2">
        <div class="container">
          <h2 class="m_ttl7">
            tin tức mới nhất<!--最新消息-->
            <span>Information</span>
          </h2>
          <div class="row justify-content-center mt-3">
            <div class="col-md-9">
              <div class="public-news-list">
                <router-link
                  v-for="news in newsList"
                  :key="news.id"
                  :to="`/news/${news.id}`"
                  class="public-news-list-item"
                >
                  <div>
                    <span class="public-news-tag mr-2">{{
                      news.category
                    }}</span>
                    <span class="public-news-list-item-date">{{
                      news.publishedAt | moment("YYYY年MM月DD日")
                    }}</span>
                  </div>
                  <div>
                    <h4>{{ news.title }}</h4>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import db from "../../api/db";
import PublicLayout from "../../components/public/PublicLayout";
export default {
  name: "HomeScreen",
  components: {
    PublicLayout,
  },
  data() {
    // FIXME: 改為從Firebase讀取資料
    // 透過後台新增圖片
    return {
      homepageSlides: [
        {
          previewUrl: require("@/assets/public/images/home/新官網首頁圖_工作區域_1.png"),
        },
        // {
        //   previewUrl:
        //     "https://fordays.jp/assets_c/2020/05/main_mask_pc_3-thumb-1440x480-1396.jpg",
        // },
        // {
        //   previewUrl:
        //     "https://fordays.jp/assets_c/2020/03/main_power_energy_pc-thumb-1440x480-1371.jpg",
        // },
        // {
        //   previewUrl:
        //     "https://fordays.jp/assets_c/2020/02/main_drink20th_pc_1_min-thumb-1440x480-1324.jpg",
        // },
        // {
        //   previewUrl:
        //     "https://fordays.jp/assets_c/2020/02/main_serum_my_pc-min-thumb-1440x480-1309.jpg",
        // },
        // {
        //   previewUrl:
        //     "https://fordays.jp/assets_c/2019/12/mv_01_pc-thumb-1440x480-1173.jpg",
        // },
        // {
        //   previewUrl:
        //     "https://fordays.jp/assets_c/2020/02/main_me2_pc-min-thumb-1440x480-1313.jpg",
        // },
      ],
      newsList: [],
    };
  },
  mounted() {
    const vm = this;
    const newsList = [];
    const newsCategoryMap = {};
    async function fetchData() {
      const newsCategoryListCollection = await db
        .collection("newsCategoryList")
        .get();
      newsCategoryListCollection.forEach((doc) => {
        const categoryTitle = doc.data().title;
        newsCategoryMap[doc.id] = categoryTitle;
      });

      const collection = await db
        .collection("newsList")
        .where("isPublished", "==", true)
        .orderBy("publishedAt", "desc")
        .get();
      collection.forEach((doc) => {
        const news = doc.data();
        news.category = newsCategoryMap[news.category];
        news.id = doc.id;
        newsList.push(news);
      });
      vm.newsList = newsList;
    }
    fetchData();
  },
};
</script>
<style lang="scss" scoped>
.m_sec2__nucleicAcid {
  padding: 60px 0;
  color: white;
  background-position: center center;
  background-size: cover;
}
.m_ttl7 {
  font-family: "Noto Serif JP", "ヒラギノ明朝 Pro", "Hiragino Mincho Pro", serif;
  font-weight: 500;
  font-size: 30px;
  text-align: center;
  line-height: 1.25;
  margin-bottom: 36px;
}
.m_ttl7 > span {
  font-family: "Roboto Condensed", sans-serif;
  display: block;
  margin-top: 24px;
  font-size: 0.53846em;
  opacity: 0.8;
  font-weight: normal;
}
.m_btn__white {
  color: #fff;
  border: 1px solid #fff;
  padding: 10px 40px;
  opacity: 1;
  display: inline-block;
}
a.m_btn__white[href]:hover,
.m_btn__white:not([disabled]):hover {
  color: #fff;
  background-color: #009cff;
  border-color: #009cff;
  opacity: 1;
}
.m_sec2 {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 60px;
  padding-bottom: 60px;
  background-color: #e6ecee;
}
.m_media_detail > .m_media_ttl {
  font-family: "Noto Serif JP", "ヒラギノ明朝 Pro", "Hiragino Mincho Pro", serif;
  font-weight: 500;
  margin-bottom: 12px;
  font-size: 20px;
  text-align: center;
}
.m_media_detail > p {
  font-size: 14px;
}
.m_sec {
  padding-top: 60px;
  padding-bottom: 60px;
}
.m_ttl3 {
  font-size: 20px;
}

.home-product-list {
  margin-top: 32px;
  img {
    width: 144px;
    margin: 0 12px;
  }
}
</style>
